import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=66334dca&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"
import style0 from "./tree.vue?vue&type=style&index=0&id=66334dca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66334dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66334dca')) {
      api.createRecord('66334dca', component.options)
    } else {
      api.reload('66334dca', component.options)
    }
    module.hot.accept("./tree.vue?vue&type=template&id=66334dca&scoped=true", function () {
      api.rerender('66334dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/fixed/components/tree.vue"
export default component.exports